// extracted by mini-css-extract-plugin
module.exports = {"cocreeSelect":"Cocree__cocreeSelect--2pd4U2js-Q3jof-67_fnO"};